import * as React from "react";
import * as styles from "./spinner.css";

const Spinner: React.FC<{}> = () => {
    return (
        <div className={styles.spinner}>
            <i className="fa fa-spinner fa-spin fa-2x"></i>
        </div>
    );
};

export { Spinner };
